import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { listClients } from "../../../api/server";
import { addClients } from "../ClientsSlice";
import { useParams } from "react-router-dom";
import { Table, Button, Input } from "antd";
import HorizontalSpacer from "../../../components/layouts/HorizontalSpacer";
import Surface from "../../../components/layouts/Surface";
import ActionsTableWrapper from "../../../components/templates/ActionsTable.style";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
var flatten = require("flat");

const AddBranchClient = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [branchClients, setBranchClients] = useState([]);
  const [totalClients, setTotalClients] = useState([]);
  const [textFilter, setTextFilter] = useState("");
  const [order, setOrder] = useState("descend");
  const [total, setTotal] = useState(0);
  const [fetchPageSize, setFetchPageSize] = useState(10);

  const [currentNumber, setCurrentNumber] = useState(1);
  const dispatch = useDispatch();
  let { branchId } = useParams();
  const intl = useIntl();
  let history = useHistory();
  const addLoading = useSelector(
    (state) => state.pendingActions["clients/addClients"]
  );
  const scopePrefix = useSelector((state) => state.user.scopePrefix);

  useEffect(() => {
    async function getClients() {
      setLoading(true);
      const clients = await listClients({
        scopePrefix,
      });
      setBranchClients(clients.data.items);
    }
    getClients();
  }, []);

  useEffect(() => {
    async function getClients() {
      setLoading(true);
      const clients = await listClients({
        current: currentNumber,
        pageSize: fetchPageSize,
        order: {
          field: "name",
          order: order,
        },
        filter: {
          freeText: textFilter,
        },
        scopePrefix: "",
      });
      setLoading(false);
      setTotalClients(clients.data.items);
      setTotal(clients.data.total);
    }
    getClients();
  }, [order, textFilter, currentNumber, fetchPageSize]);

  useEffect(() => {
    let flatList = [];
    for (let i = 0; i < totalClients.length; i++) {
      const flattenItem = flatten(totalClients[i]);
      flattenItem["key"] = flattenItem.id;
      for (let j = 0; j < branchClients.length; j++) {
        if (branchClients[j].id === flattenItem.id) {
          flattenItem["disabled"] = true;
        }
      }
      flatList.push(flattenItem);
    }
    setData(flatList);
  }, [totalClients, branchClients]);

  const ltrItems = ["phone_number"];
  let columns = [
    {
      title: <FormattedMessage id={"app.clients.name"} />,
      dataIndex: "name",
      sorter: (a, b) => a["name"].localeCompare(b["name"]),
      sortDirections: ["descend", "ascend"],
      render(text, record) {
        return {
          children: <div className="content">{text}</div>,
        };
      },
    },
  ];

  const tableItems = [
    "address.city",
    "address.street",
    "address.house_number",
    "phone_number",
    "fax_number",
    "email",
  ];
  tableItems.forEach(function (item) {
    const title = "app.clients." + item;
    const i = {
      title: <FormattedMessage id={title} />,
      dataIndex: item,
      render(text, record) {
        return {
          props: {
            style: {
              direction:
                ltrItems && ltrItems.includes(item) ? "ltr" : "inherit",
            },
          },
          children: <div className="content">{text}</div>,
        };
      },
    };

    columns.push(i);
  });

  const onChange = (
    { current, pageSize },
    filters,
    { field, order },
    extra
  ) => {
    setOrder(order);
    setCurrentNumber(current);
    setFetchPageSize(pageSize);
  };

  const pagination = {
    current: currentNumber,
    pageSize: fetchPageSize,
    total: total,
    pageSizeOptions: [10, 50, 100],
    showSizeChanger: true,
  };

  const onTextChange = (e) => {
    setTextFilter(e.target.value);
    setCurrentNumber(1);
  };

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.disabled, // Column configuration not to be checked
      name: record.name,
    }),
  };
  const onAddClick = async () => {
    const params = { branchId: branchId, clients: selectedRowKeys };
    const action = await dispatch(addClients(params));
    if (!action.error) {
      history.goBack();
    }
  };

  return (
    <Surface>
      <ActionsTableWrapper>
        <HorizontalSpacer style={{ paddingBottom: 20 }}>
          <Input
            placeholder={intl.formatMessage({
              id: "app.clients.typeClientName",
            })}
            value={textFilter}
            onChange={onTextChange}
            style={{ width: 200 }}
            size="large"
          />
          <Button
            type="primary"
            size="large"
            onClick={onAddClick}
            disabled={selectedRowKeys.length === 0}
            loading={addLoading}
          >
            {intl.formatMessage({
              id: "app.clients.addClientToBranch",
            })}
          </Button>
        </HorizontalSpacer>
        <span style={{ marginLeft: 8 }}>
          {intl.formatMessage({
            id: "app.clients.selected",
          })}
          {` ${selectedRowKeys.length} `}
          {intl.formatMessage({
            id: "app.clients.clients",
          })}
        </span>
        <Table
          bordered
          loading={loading}
          rowSelection={rowSelection}
          columns={columns}
          pagination={pagination}
          dataSource={data}
          onChange={onChange}
          rowClassName={(record, index) => (record.disabled ? "disabled" : "")}
          scroll={{
            y: window.innerHeight - 460,
          }}
        />
      </ActionsTableWrapper>
    </Surface>
  );
};

export default AddBranchClient;
